"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeEligibleTiersWarningModal = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var AnnualHomeEligibleTiersWarningModal = /** @class */ (function (_super) {
    __extends(AnnualHomeEligibleTiersWarningModal, _super);
    function AnnualHomeEligibleTiersWarningModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isTierWarningModalOpen: false,
            tieredUnderwritingResult: _this.props.interaction.tieredUnderwritingResult
        };
        _this.toggle = _this.toggle.bind(_this);
        _this.updateModalVisibility = _this.updateModalVisibility.bind(_this);
        return _this;
    }
    AnnualHomeEligibleTiersWarningModal.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        var tierWarningWordingElement = this.getTierWarningWordingAsElement();
        var isTierWarningWordingElementPopulated = React.Children.count(tierWarningWordingElement.props.children) > 0;
        if (isTierWarningWordingElementPopulated && !this.state.isTierWarningModalOpen) {
            this.updateModalVisibility();
        }
        if (isTierWarningWordingElementPopulated && this.state.isTierWarningModalOpen) {
            return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.isTierWarningModalOpen, toggle: this.toggle },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", null,
                            React.createElement("img", { className: "mr-2 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" })),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Because of the changes you've made..."))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0" }, tierWarningWordingElement),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggle }, "Ok, I understand"))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeEligibleTiersWarningModal.prototype.getTierWarningWordingAsElement = function () {
        var wordingType = this.props.interaction.eligibleTier;
        var tiers = new Map();
        tiers.set(services_1.BRONZE_TIER, "Bronze");
        tiers.set(services_1.SILVER_TIER, "Silver");
        tiers.set(services_1.GOLD_TIER, "Gold");
        var goldTier = tiers.get(services_1.GOLD_TIER);
        var initialUwResult = this.state.tieredUnderwritingResult;
        var newUwResult = this.props.interaction.tieredUnderwritingResult;
        var bronzeChanged = this.tierResultChanged(services_1.BRONZE_TIER, initialUwResult, newUwResult);
        var silverChanged = this.tierResultChanged(services_1.SILVER_TIER, initialUwResult, newUwResult);
        var goldChanged = this.tierResultChanged(services_1.GOLD_TIER, initialUwResult, newUwResult);
        if (bronzeChanged || silverChanged || goldChanged) {
            var wording = void 0;
            if (wordingType === services_1.BRONZE_TIER) {
                wording = React.createElement("span", null,
                    "...you're now only eligible for our ",
                    React.createElement("b", null, tiers.get(services_1.BRONZE_TIER)),
                    ", ",
                    React.createElement("b", null, tiers.get(services_1.SILVER_TIER)),
                    " and ",
                    React.createElement("b", null, goldTier),
                    " policy.");
            }
            else if (wordingType === services_1.SILVER_TIER) {
                wording = React.createElement("span", null,
                    "...you're now only eligible for our ",
                    React.createElement("b", null, tiers.get(services_1.SILVER_TIER)),
                    " and ",
                    React.createElement("b", null, goldTier),
                    " policy.");
            }
            else {
                wording = React.createElement("span", null,
                    "...you're now only eligible for our ",
                    React.createElement("b", null, goldTier),
                    " policy.");
            }
            return wording;
        }
        return React.createElement(React.Fragment, null);
    };
    AnnualHomeEligibleTiersWarningModal.prototype.toggle = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen,
            tieredUnderwritingResult: this.props.interaction.tieredUnderwritingResult
        });
    };
    AnnualHomeEligibleTiersWarningModal.prototype.updateModalVisibility = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen
        });
    };
    AnnualHomeEligibleTiersWarningModal.prototype.tierResultChanged = function (tier, oldUwResult, newUwResult) {
        var previouslyDeclined = oldUwResult.filter(function (uw) { return uw.tier === tier; })[0].underwritingFailures.length > 0;
        var declinedNow = newUwResult.filter(function (uw) { return uw.tier === tier; })[0].underwritingFailures.length > 0;
        return previouslyDeclined !== declinedNow;
    };
    return AnnualHomeEligibleTiersWarningModal;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeEligibleTiersWarningModal = AnnualHomeEligibleTiersWarningModal;
//# sourceMappingURL=AnnualHomeEligibleTiersWarningModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeEligibleTiersWarningModal.js
// module id = 3713
// module chunks = 0